import React, { Component } from "react";
import down from "../../../../assets/icons/down.svg";
import down_infer from "../../../../assets/icons/down_infer.svg";
import "../styles/global.css";

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
      headerTitle: this.props.title
    };
    this.close = this.close.bind(this);
  }

  componentDidUpdate() {
    const { listOpen } = this.state;
    setTimeout(() => {
      if (listOpen) {
        window.addEventListener("click", this.close);
      } else {
        window.removeEventListener("click", this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.close);
  }

  close(timeOut) {
    this.setState({
      listOpen: false
    });
  }

  componentDidMount() {
    this.setState({
      headerTitle: this.props.default
    });
  }

  selectItem(title, id, stateKey) {
    this.setState(
      {
        headerTitle: title,
        listOpen: false
      },
      this.props.resetThenSet(id, stateKey)
    );
  }

  toggleList() {
    this.setState(prevState => ({
      listOpen: !prevState.listOpen
    }));
  }

  render() {
    const { list } = this.props;
    const { listOpen, headerTitle } = this.state;
    let type, bgColor, margin, heightI
    if(this.props.buttonType === 'down_svg') {
      type = down_infer
      margin = '-3.5px'
    } else {
      type = down
      heightI = '20px'
      bgColor = '#17D9AA'
      margin = '-1px'
    }
    return (
      <div
        className="dd-wrapper"
        style={{
          width: this.props.width,
          padding: "2px",
          padding:this.props.padding,
          border: "0",
          borderRadius: "0",
          border: this.props.bStyle,
          borderRadius: this.props.bRadius
        }}
      >
        <div
          className="dd-header"
          style={{ backgroundColor: this.props.hbackgroud, height: '20px' }}
          onClick={() => this.toggleList()}
        >
          <div className="dd-header-title">{headerTitle}</div>
          {listOpen ? (
            <img
              style={{
                backgroundColor: bgColor,
                /* backgroundColor: this.props.hbackgroud */ borderRadius: "3px",
                height: heightI,
                transform: "rotate(-180deg)"
              }}
              src={type}
            />
          ) : (
            <img
              style={{
                backgroundColor: bgColor,
                height: heightI,
                /* backgroundColor: this.props.hbackgroud */ borderRadius: "3px"
              }}
              src={type}
            />
          )}
        </div>
        {listOpen && (
          <ul
            className="dd-list"
            style={{
              backgroundColor: this.props.hbackgroud,
              overflow: "hidden",
              marginLeft: "-3.5px",
              marginLeft: margin,
              marginTop: "1px"
            }}
            onClick={e => e.stopPropagation()}
          >
            {list.map(item => (
              <li
                className="dd-list-item"
                key={item.id}
                onClick={() => this.selectItem(item.title, item.id, item.key)}
              >
                {item.title}{" "}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}

export default Dropdown;
